import { BLUE, BLUE_PRESSED, BORDER, INTER, NAVY, POPPINS, SLATE } from '../mockupPalette';

// The public home and login mockups wrap the shared mockup palette; they do not fork it.
export * from '../mockupPalette';

export const PAGE_GUTTER = { xs: 2, sm: 3, md: 4 } as const;
export const CONTENT_MAX_WIDTH = 1120;

export const cardSx = {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${BORDER}`,
    borderRadius: '20px',
} as const;

export const sectionTitleSx = {
    fontFamily: POPPINS,
    fontWeight: 600,
    fontSize: { xs: 24, md: 30 },
    lineHeight: 1.25,
    color: NAVY,
} as const;

export const sectionLeadSx = {
    fontFamily: INTER,
    fontSize: { xs: 15, md: 17 },
    lineHeight: 1.6,
    color: SLATE,
} as const;

export const primaryButtonSx = {
    minHeight: 48,
    px: 3,
    borderRadius: '11px',
    fontFamily: INTER,
    fontWeight: 700,
    fontSize: 15,
    backgroundColor: BLUE,
    color: '#FFFFFF',
    '&:hover': { backgroundColor: BLUE_PRESSED },
} as const;
